const HEX_COLOR_PATTERN = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

export function hexToRgba(hex: string, alpha: number): string | null {
  if (!HEX_COLOR_PATTERN.test(hex)) {
    return null;
  }
  const digits = hex.slice(1);
  const fullDigits =
    digits.length === 3
      ? digits
          .split('')
          .map((digit) => digit + digit)
          .join('')
      : digits;
  const red = parseInt(fullDigits.slice(0, 2), 16);
  const green = parseInt(fullDigits.slice(2, 4), 16);
  const blue = parseInt(fullDigits.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}
